import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  state: {
    showHeader: true
  },
  mutations: {
    setHeader (state, isVisible) {
      state.showHeader = isVisible
    }
  },
  strict: process.env.NODE_ENV === 'development'
})
